import { useBookingDraftQuery } from '../../domain/hooks';
import { useIntl } from '@/intl/useIntl';
import { CheckoutSection } from '../CheckoutSection';
import { ServiceIcon } from '../ServiceIcon';
import { Typography } from '@sunwebgroup/uds-ui/typography';
import styles from './Extras.module.css';

function Extras() {
  const intl = useIntl();
  const { data } = useBookingDraftQuery();

  const extras = data?.confirmation?.services
     ?.map((service) => ({
       ...service,
       lines: service.lines.filter(
         (line) => line.isIncluded !== true && (line.participantIds?.length ?? 0) > 0
       ),
     }))
     .filter((service) => service.lines.length > 0);
  if (!extras || extras.length === 0) {
    return null;
  }

  return (
    <CheckoutSection glyph="PlusInSquare" title={intl.formatMessage({ id: 'common_extras' })}>
      <div className={styles.extraContainer}>
        {extras.map((extra) => (
          <div key={extra.title} className={styles.extraContent}>
            <ServiceIcon type={extra.serviceAName ?? ''} size={24} className={styles.extraIcon} />
            <div className={styles.extraText}>
              <Typography className={styles.extraTitle} as="p" variant="body-s-regular-tight">
                {extra.title}
              </Typography>
              <div className={styles.extraLines}>
                {extra.lines.map((line) => (
                  <Typography key={`${extra.title}-${line.text}`} as="p" variant="body-m-bold-tight">
                    {line.text}
                  </Typography>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </CheckoutSection>
  );
}

export default Extras;
